import React from "react";
import { Scope } from "informed";

import {
	ColorPicker,
	FileInput,
	BorderStylePicker,
	NumberInput,
	GradientInput,
	CheckBox,
	ShadowInput,
} from "../../../../../shared/Forms";
import { renderFields } from "../helper";

const HeaderFooter = ({ scope }) => {
	const fields = [
		<ColorPicker field="textColor" id="textColor" placeholder="Text Color" themeBuilderInputType="ColorPicker" />,
		<ColorPicker
			field="backgroundColor"
			id="backgroundColor"
			placeholder="Background Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<FileInput
			field="backgroundImageUrl"
			id="backgroundImageUrl"
			placeholder="Background Image URL"
			themeBuilderInputType="FileInput"
		/>,
		<GradientInput
			field="backgroundGradient"
			id="backgroundGradient"
			placeholder="Background Gradient"
			themeBuilderInputType="GradientInput"
		/>,
		<NumberInput
			field="marginVertical"
			id="marginVertical"
			placeholder="Vertical Margin"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="marginHorizontal"
			id="marginHorizontal"
			placeholder="Horizontal Margin"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingVertical"
			id="paddingVertical"
			placeholder="Vertical Padding"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="paddingHorizontal"
			id="paddingHorizontal"
			placeholder="Horizontal Padding"
			themeBuilderInputType="NumberInput"
		/>,
		<BorderStylePicker
			field="borderStyle"
			id="borderStyle"
			placeholder="Border Styles"
			themeBuilderInputType="BorderStylePicker"
		/>,
		<ColorPicker
			field="borderColor"
			id="borderColor"
			placeholder="Border Color"
			themeBuilderInputType="ColorPicker"
		/>,
		<NumberInput
			field="borderWidth"
			id="borderWidth"
			placeholder="Border Width"
			themeBuilderInputType="NumberInput"
		/>,
		<NumberInput
			field="borderRadius"
			id="borderRadius"
			placeholder="Border Radius"
			max={768}
			themeBuilderInputType="NumberInput"
		/>,
		<CheckBox
			field="borderTopOn"
			id={`${scope}-borderTopOn`}
			label="Border Top"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<CheckBox
			field="borderLeftOn"
			id={`${scope}-borderLeftOn`}
			label="Border Left"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<CheckBox
			field="borderRightOn"
			id={`${scope}-borderRightOn`}
			label="Border Right"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<CheckBox
			field="borderBottomOn"
			id={`${scope}-borderBottomOn`}
			label="Border Bottom"
			textalign="center"
			themeBuilderInputType="CheckBox"
		/>,
		<ShadowInput field="boxShadow" id="boxShadow" placeholder="Box Shadow" themeBuilderInputType="ShadowInput" />,
		<ShadowInput
			field="textShadow"
			type="text"
			id="textShadow"
			placeholder="Text Shadow"
			themeBuilderInputType="ShadowInput"
		/>,
	];
	return (
		<div className="theme-columns">
			<Scope scope={scope}>
				<div className="theme-column">
					<h4 className="header">{scope}</h4>
					<div className="theme-content">{renderFields(fields)}</div>
				</div>
			</Scope>
		</div>
	);
};

export default HeaderFooter;
